import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import React, { useState } from "react";
import { RecordState, deleteDataAction } from "../Store/Generic/GenericSlice";
import '../global/GlobalCSS.css';
import DeletePopOver from '../Components/DeletePopOver';

export default function DeleteModel() {
    const dispatch = useDispatch();
    const { recordID, recordState } = useSelector(
        (state: any) => state.Generic
    );
    const [popoverState, setPopoverState] = useState(false);
    const { masters } = useParams();
    const DeleteRecordState: RecordState = 'DELETE';

    const handleDelete = () => {
        dispatch(deleteDataAction(masters as string, recordID));
    }

    if (recordState !== DeleteRecordState) return null;

    return (
        <>
            <DeletePopOver target='delete_details' onClick={handleDelete} state={popoverState} setState={setPopoverState} />
        </>
    )
}
